import { Accordion } from './Accordion';

export * from './Accordion';

export default Accordion;
